import { P2Button, P2Checkbox, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import ApplicationCooLayout from '../../../layout/application-coo-layout';
import { useState } from 'react';
import PdfIcon from '../../../assets/svg/pdf';
import { Separator } from '../../../components/separator';
import { ClockSvg, FileCheckSvg } from '../../../assets/svg';
import { useNavigate } from 'react-router-dom';
import useViewportWidth from '../../../components/stepper/useViewportWidth';
import { HDBLinks } from '../../../utils/shared/links';

function StageECpfLanding() {
  const isDesktopView = useViewportWidth();
  let navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get('application_id');
  const [agreed, setAgreed] = useState<boolean>(false);

  const handleNavigateBack = () => {
    navigate(`/application-coo/stage-e/prepare-for-completion?application_id=${application_id}`);
  };

  const handleProceedNext = () => {
    navigate(`/application-coo/stage-e/overview?application_id=${application_id}`);
  };

  const termsStringwLink = (
    <>
      <span> I agree and accept the </span>
      <a
        className='polymer-text-links'
        target='_blank'
        rel='noreferrer'
        href={`${process.env.PUBLIC_URL}/documents/A1_Terms and Conditions for Application for Use of CPF Savings and Home Protection Scheme.pdf`}>
        Terms and Conditions
      </a>
      <span>, and wish to proceed with this application.</span>
    </>
  );

  const privacyStringwLink = (
    <div>
      <p>
        Please read the{' '}
        <a className='polymer-text-links' rel='noreferrer' target='_blank' href={HDBLinks.private_statement}>
          Privacy Statement
        </a>{' '}
        and{' '}
        <a className='polymer-text-links' rel='noreferrer' target='_blank' href={HDBLinks.terms_of_use}>
          Terms of Use
        </a>{' '}
        before proceeding further.
      </p>
    </div>
  );

  const info = [
    'Co-applicants using their CPF savings for the ownership change must also submit a CPF withdrawal form, after submitting the application for the change in flat ownership.',

    'The withdrawal of your CPF savings will take about 10 working days to process. You will need to submit a new application/ make payment in cash, if your application is unsuccessful. Please note that the ownership change can be completed only after all payments have been made.',

    'If you an existing owner with Home Protection Scheme (HPS) cover and wish to remain covered under HPS, you will need to submit a new HPS application to adjust your coverage due to a new housing loan upon the transfer of ownership.',

    'You will need to apply for the Home Protection Scheme (HPS) to use your CPF savings to pay the monthly housing loan instalments.',

    privacyStringwLink,
  ];

  return (
    <ApplicationCooLayout title='Apply to Withdraw CPF Funds Due to Change in Flat Ownership'>
      <div className='polymer-application-coo__wrapper cpf-service-landing-wrapper'>
        <div className='d-flex justify-content-center align-items-center bottom32 mx-auto cpf-service-header'>
          <P2TextDescription
            color='#333'
            description={
              'Apply to use your CPF savings to pay for your flat, and apply for the Home Protection Scheme (HPS), due to a change in flat ownership.'
            }
          />
        </div>

        <div className='d-flex flex-column flex-md-row align-items-center align-items-md-start bottom32 flex-gap'>
          {/* Card 1 */}
          <div className='d-flex flex-column justify-content-evenly polymer-stage-e_white-card'>
            <div className='d-flex polymer-stage-e-icon-gap align-items-center'>
              <div>
                <ClockSvg />
              </div>
              <p style={{ marginBottom: 0 }}>10 minutes to complete</p>
            </div>
            <Separator />
            <div className='d-flex polymer-stage-e-icon-gap align-items-center'>
              <div>
                <FileCheckSvg />
              </div>
              <p style={{ marginBottom: 0 }}>You will need to have a confirmed financial plan before starting this e-Service</p>
            </div>
            <Separator />
            <div className='d-flex polymer-stage-e-icon-gap align-items-center'>
              <div>
                <FileCheckSvg />
              </div>
              <p style={{ marginBottom: 0 }}>Health declaration if you are applying for HPS</p>
            </div>
          </div>
          {/* Card 2 */}
          <div className='d-flex flex-row polymer-stage-e-icon-gap polymer-stage-e_green-card'>
            <div>
              <PdfIcon />
            </div>
            <div>
              Please ensure that you have sufficient CPF savings (available for housing) before submitting your application. You may check your CPF
              balance through{' '}
              <span>
                <a href='https://www.cpf.gov.sg' target='_blank' rel='noreferrer' className='polymer-text-links'>
                  CPF Board's website.
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Notes */}
        <div className='d-flex flex-column justify-content-center cpf-service-important-notes'>
          <P2TextLabel fontSize={'20px'} lineHeight={'24px'} bold={700} label={'Important Notes.'} />
          <ol style={{ marginTop: '0', paddingLeft: '1.5rem' }}>
            {info.map((item, _index) => (
              <li style={{ paddingLeft: '0.5rem', lineHeight: '20px' }} key={_index}>
                <P2TextDescription description_size={'16px'} color='#333' description={item} />
              </li>
            ))}
          </ol>
        </div>

        <div className='polymer-stage-e_checkbox-wrapper' onClick={() => setAgreed((prev) => !prev)} style={{ cursor: 'pointer' }}>
          <P2Checkbox variant={'default'} isActive={agreed} />
          <div> {termsStringwLink}</div>
        </div>
        <div className='cpf-service-landing-btn-grp' style={{ marginTop: '64px', gap: '24px' }}>
          <P2Button onClick={() => handleNavigateBack()} variant={'outline-primary'}>
            Back
          </P2Button>
          <P2Button onClick={() => handleProceedNext()} disabled={!agreed} variant={'primary-1'}>
            Proceed
          </P2Button>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}

export default StageECpfLanding;
